import { render, staticRenderFns } from "./MarketColumnDropdown.vue?vue&type=template&id=3ca874ec&scoped=true"
import script from "./MarketColumnDropdown.vue?vue&type=script&lang=js"
export * from "./MarketColumnDropdown.vue?vue&type=script&lang=js"
import style0 from "./MarketColumnDropdown.vue?vue&type=style&index=0&id=3ca874ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca874ec",
  null
  
)

export default component.exports